export default theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: 24
  },
  summaryBox: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 16,
    borderRadius: 8,
    backgroundColor: '#f5f6fc'
  },
  icon: {
    marginRight: 8
  }
});